import React from "react";
import { Box } from "@mui/material";
import background from "@/assets/images/background.svg";

import { LoginForm } from "@/components/LoginForm";
import { Toaster } from "@/components/ui/sonner";

export const LoginPage: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#14452C",
          height: "100%",
          width: { xs: "100%", lg: "50%" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoginForm />
        <Toaster position="bottom-right" richColors />
      </Box>
    </Box>
  );
};

export default LoginPage;
